import { render, staticRenderFns } from "./LandPageContact.vue?vue&type=template&id=64ab8e80&scoped=true"
import script from "./LandPageContact.vue?vue&type=script&lang=js"
export * from "./LandPageContact.vue?vue&type=script&lang=js"
import style0 from "./LandPageContact.vue?vue&type=style&index=0&id=64ab8e80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab8e80",
  null
  
)

export default component.exports